import { ALBUM_FOLDER_ONBOARDING_TYPE } from '../../../../../constants/album-folder';

/**
 * @enum MARKETING_MATERIAL_TYPE
 * @type {{ONBOARDING_FLYER: string, WEDDING_TABLE_TENT: string, ONBOARDING_SOCIAL: string, SHUTTERBUG_TABLE_TENT: string, QR_CODE_SHARE: string, EVENT_FLYER_VIDEO_GUESTBOOK: string, PROFILE_PAGE_SOCIAL: string, EVENT_FLYER: string, WEDDING_FLYER: string, SHUTTERBUG_FLYER: string, WEDDING_FLYER_VIDEO_GUESTBOOK: string, EVENT_TABLE_TENT: string}}
 */
export const MARKETING_MATERIAL_TYPE = {
  ONBOARDING_SOCIAL: 'ONBOARDING_SOCIAL',
  ONBOARDING_FLYER: 'ONBOARDING_FLYER',
  PROFILE_PAGE_SOCIAL: 'PROFILE_PAGE_SOCIAL',
  WEDDING_FLYER: 'WEDDING_FLYER',
  WEDDING_TABLE_TENT: 'WEDDING_TABLE_TENT',
  WEDDING_FLYER_VIDEO_GUESTBOOK: 'WEDDING_FLYER_VIDEO_GUESTBOOK',
  SHUTTERBUG_FLYER: 'SHUTTERBUG_FLYER',
  SHUTTERBUG_TABLE_TENT: 'SHUTTERBUG_TABLE_TENT',
  QR_CODE_SHARE: 'QR_CODE_SHARE',
  EVENT_FLYER: 'EVENT_FLYER',
  EVENT_FLYER_VIDEO_GUESTBOOK: 'EVENT_FLYER_VIDEO_GUESTBOOK',
  EVENT_TABLE_TENT: 'EVENT_TABLE_TENT',
  BUSINESS_CARD: 'BUSINESS_CARD',
};

/**
 * Marketing material types that support a photographer-uploaded custom design
 * (MarketingMaterialAsset) instead of the default generated material.
 */
export const MARKETING_MATERIAL_CUSTOM_DESIGN_TYPES = [
  MARKETING_MATERIAL_TYPE.ONBOARDING_FLYER,
];

export const MARKETING_MATERIAL_PRIMARY_TEXT_DISPLAY_ENUM = {
  NONE: 'NONE',
  EVENT_NAME: 'EVENT_NAME',
};

export const MARKETING_MATERIAL_SECONDARY_TEXT_DISPLAY_ENUM = {
  NONE: 'NONE',
  EVENT_DATE_AND_LOCATION: 'EVENT_DATE_AND_LOCATION',
  PERSONALIZED_MESSAGE: 'PERSONALIZED_MESSAGE',
};

/**
 * Sell photos flyer "find" step copy for galleries with facial recognition
 * disabled, keyed by the AlbumFolder onboarding type (DEFAULT = name search).
 */
export const FLYER_SELL_PHOTOS_FACE_REC_OFF_FIND_STEP_COPY = {
  DEFAULT: 'Enter the name of the person you want Waldo to find.',
  [ALBUM_FOLDER_ONBOARDING_TYPE.REF_ID]:
    'Enter the ID of the person you want Waldo to find.',
  [ALBUM_FOLDER_ONBOARDING_TYPE.GRADE]:
    'Enter the grade and name of the person you want Waldo to find.',
};

/**
 * Custom design flyer "join" step copy for galleries with facial recognition
 * disabled, keyed by the AlbumFolder onboarding type (DEFAULT = name search).
 */
export const CUSTOM_DESIGN_FACE_REC_OFF_JOIN_STEP_COPY = {
  DEFAULT: 'Find the person we photographed by name to join the event.',
  [ALBUM_FOLDER_ONBOARDING_TYPE.REF_ID]:
    'Enter the ID of the person we photographed to join the event.',
  [ALBUM_FOLDER_ONBOARDING_TYPE.GRADE]:
    'Find the person we photographed by grade and name to join the event.',
};
